<template>
  <div class="wrapper border-bottom white-bg page-heading">
		<div class="container">
			<div class="row">
				<div class="col-xs-12">
          <heading-loading v-if="loading"></heading-loading>
          <h1 v-else><i class="far fa-map-signs m-r-sm"></i> {{ location.name }}</h1>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
  import { mapState } from 'vuex'
  import { helpers } from 'mixins/locations'
  import { headingLoading } from 'mixins'

  export default {
    mixins: [helpers, headingLoading],

    computed: mapState('location', ['location'])
  }
</script>



// WEBPACK FOOTER //
// EditHeading.vue?efdef7de